// extracted by mini-css-extract-plugin
export default {"Footer":"styles_Footer__-DtUs"};